<template lang="html">
  <div>
    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>

    <v-container
      v-if="course"
      fluid
      class="pa-0 ma-0"
    >
      <slot name="navigation" />
      <v-row>
        <v-col
          cols="12"
        >
          <v-col
            cols="12"
          >
            <v-card
              class="mx-auto"
            >
              <v-list-item
                class="ml-0 pt-1 white--text"
                style="background:#00896e url(https://www.transparenttextures.com/patterns/bright-squares.png) repeat !important"
              >
                <v-list-item-avatar size="100">
                  <img
                    :src="course.image_url"
                  >
                </v-list-item-avatar>

                <v-list-item-content class="white--text">
                  <v-list-item-title class="headline">
                    {{ course.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="white--text">
                    {{ course.description }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-tabs v-model="active">
                <v-tab>Course Details</v-tab>
                <v-tab v-if="$hasPermissionTo(['setup course material view'])">
                  Materials
                </v-tab>
                <v-tab v-if="$hasPermissionTo(['setup training session view'])">
                  Training Sessions
                </v-tab>
                <!-- <v-tab v-if="$hasPermissionTo(['setup exam view'])">
                  Setup Exams
                </v-tab> -->
              </v-tabs>

              <v-tabs-items 
                v-model="active"
              > 
                <v-tab-item v-show="active === 0">
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <setup-training-courses-form-edit
                          :course-id="course.id"
                          @updated="loadCourse()"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>

                <v-tab-item
                  v-show="active === 1"
                  v-if="$hasPermissionTo(['setup course material view'])"
                >
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <setup-training-course-materials-container-view
                          :course-id=" course.id"
                        /> 
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>

                <v-tab-item
                  v-show="active === 2"
                  v-if="$hasPermissionTo(['setup training session view'])"
                >
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <setup-training-training-sessions-container-view
                          :course-id=" course.id"
                        /> 
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>

                <v-tab-item v-show="active === 3">
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <setup-training-exams-container-view
                          :course-id=" course.id"
                        /> 
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    components: {
      SetupTrainingCoursesFormEdit: () => import('./FormEdit'),
      SetupTrainingCourseMaterialsContainerView: () => import('@/components/setup/training/course-materials/ContainerView'),
      SetupTrainingTrainingSessionsContainerView: () => import('@/components/setup/training/training-sessions/ContainerView'),
      SetupTrainingExamsContainerView: () => import('@/components/setup/training/exams/ContainerView'),
    },
    props: {
      courseId: {
        type: Number,
        default: null,
      },     
    },
    data () {
      return {
        active: 0,   
        loading: false,    
      }
    },
    computed: {
      ...mapGetters({
        course: 'course/currentCourse',
      }),
    },    
    watch: {
      courseId: {
        immediate: true,
        handler (oldValue, newValue) {
          if (newValue || (oldValue !== newValue)) {            
            this.loadCourse()
            this.edit = false
          }
        },
      },
    },
    methods: {
      loadCourse () {
        this.loading = true

        this.$store.dispatch('course/getCurrentCourse', this.courseId)
          .then(() => {           
            this.loading = false
          })
      },
    },
   
  }
</script>

<style lang='css' scoped>
</style>
